<header class="bg-white border-b border-sdi-gray-100 sticky top-0 z-50">
  <div class="max-w-[1440px] mx-auto px-4 md:px-10 h-18 flex items-center justify-between">
    <div class="flex items-center gap-4 md:gap-12">
      <!-- Hamburger Menu (Mobile Only) -->
      <button 
        (click)="isMobileMenuOpen.set(true)"
        class="md:hidden p-2 text-sdi-gray-600 hover:bg-sdi-gray-50 rounded-lg transition-colors"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      <div class="flex items-center gap-2 cursor-pointer" routerLink="/">
        <span class="text-lg md:text-xl font-bold text-sdi-royal tracking-tight">Proyectos Internos</span>
      </div>
      
      <!-- Desktop Navigation -->
      <nav class="hidden md:flex items-center gap-2">
        <a 
          routerLink="/dashboard" 
          routerLinkActive="bg-sdi-gray-50 text-sdi-royal font-semibold"
          class="px-4 py-2 rounded-lg text-sdi-gray-500 hover:bg-sdi-gray-50 transition-all text-sm font-medium"
        >Dashboard</a>
        <a 
          routerLink="/initiatives" 
          [routerLinkActiveOptions]="{exact: false}"
          routerLinkActive="bg-sdi-gray-50 text-sdi-royal font-bold underline-offset-8"
          class="px-4 py-2 rounded-lg text-sdi-gray-500 hover:bg-sdi-gray-50 transition-all text-sm font-medium"
        >Iniciativas</a>
        @if (user()?.role === 'admin' || user()?.role === 'director') {
          <a 
            routerLink="/direction-tasks" 
            [routerLinkActiveOptions]="{exact: false}"
            routerLinkActive="bg-sdi-gray-50 text-sdi-royal font-bold underline-offset-8"
            class="px-4 py-2 rounded-lg text-sdi-gray-500 hover:bg-sdi-gray-50 transition-all text-sm font-medium"
          >Tareas Dirección</a>
        }
        @if (user()?.role === 'admin') {
          <a 
            routerLink="/user-management" 
            routerLinkActive="bg-sdi-gray-50 text-sdi-royal font-semibold"
            class="px-4 py-2 rounded-lg text-sdi-gray-500 hover:bg-sdi-gray-50 transition-all text-sm font-medium"
          >Usuarios</a>
        }
      </nav>
    </div>

    <div class="flex items-center gap-2 md:gap-4">
      <!-- Notification Bell -->
      <div class="relative">
        <button 
          (click)="isNotificationsOpen.set(!isNotificationsOpen())"
          class="w-10 h-10 flex items-center justify-center text-sdi-gray-500 hover:bg-sdi-gray-50 rounded-full transition-all relative"
          title="Notificaciones"
        >
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
          @if (unreadCount() > 0) {
            <span class="absolute top-1.5 right-1.5 w-4 h-4 bg-rose-500 text-white text-[9px] font-black rounded-full flex items-center justify-center border-2 border-white">
              {{ unreadCount() }}
            </span>
          }
        </button>

        <!-- Notification Dropdown -->
        @if (isNotificationsOpen()) {
          <div class="absolute right-0 mt-3 w-80 max-h-[480px] bg-white border border-sdi-gray-100 rounded-2xl shadow-2xl z-[60] overflow-hidden flex flex-col animate-in fade-in zoom-in duration-200">
            <div class="px-5 py-4 border-b border-sdi-gray-50 bg-sdi-gray-50/50 flex justify-between items-center">
              <span class="text-xs font-black text-sdi-gray-900 uppercase tracking-widest">Vencimientos Próximos</span>
              <button (click)="isNotificationsOpen.set(false)" class="text-sdi-gray-400 hover:text-sdi-gray-600">
                <i class="ri-close-line text-lg"></i>
              </button>
            </div>
            
            <div class="flex-1 overflow-y-auto p-2 space-y-1">
              @for (notif of notifications(); track notif.id + notif.type) {
                <div 
                  [routerLink]="notif.type === 'initiative' ? ['/initiatives', notif.id] : ['/direction-tasks', notif.id]"
                  (click)="isNotificationsOpen.set(false)"
                  class="flex items-center gap-4 p-3 rounded-xl hover:bg-sdi-gray-50 transition-all cursor-pointer group"
                >
                  <div class="w-2.5 h-2.5 rounded-full shrink-0" 
                    [ngClass]="{
                      'bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.4)]': notif.days_remaining >= 7,
                      'bg-amber-500 shadow-[0_0_8px_rgba(245,158,11,0.4)]': notif.days_remaining < 7
                    }">
                  </div>
                  <div class="flex-1 min-w-0">
                    <div class="text-[11px] font-black uppercase tracking-tighter opacity-40 mb-0.5" 
                      [ngClass]="notif.type === 'initiative' ? 'text-sdi-royal' : 'text-indigo-600'">
                      {{ notif.type === 'initiative' ? 'Iniciativa' : 'Tarea' }}
                    </div>
                    <div class="text-xs font-bold text-sdi-gray-800 truncate group-hover:text-sdi-royal transition-colors">
                      {{ notif.title }}
                    </div>
                    <div class="text-[10px] text-sdi-gray-400 font-medium mt-0.5">
                      Vence el {{ notif.due_date | date:'dd MMM' }} ({{ notif.days_remaining }} días)
                    </div>
                  </div>
                </div>
              } @empty {
                <div class="py-12 text-center">
                  <i class="ri-notification-off-line text-3xl text-sdi-gray-100 mb-2"></i>
                  <p class="text-xs text-sdi-gray-400 font-medium">Sin avisos próximos</p>
                </div>
              }
            </div>
          </div>
          
          <!-- Modal Backdrop for clicking away -->
          <div class="fixed inset-0 z-50 h-screen w-screen" (click)="isNotificationsOpen.set(false)"></div>
        }
      </div>
      
      <div class="group relative">
        <button class="flex items-center gap-2 p-1 rounded-full hover:bg-sdi-gray-50 transition-all border border-transparent hover:border-sdi-gray-100">
          <div class="w-8 h-8 rounded-full bg-sdi-royal text-white flex items-center justify-center text-[10px] md:text-xs font-bold ring-2 ring-white shadow-sm">
            {{ initials() }}
          </div>
          <span class="hidden md:block text-xs font-bold text-sdi-gray-700">{{ user()?.name }}</span>
        </button>
        
        <!-- Quick Dropdown -->
        <div class="absolute right-0 mt-2 w-48 bg-white border border-sdi-gray-100 rounded-xl shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 py-2">
          <div class="px-4 py-2 border-b border-sdi-gray-50 mb-2">
            <span class="block text-sm font-bold text-sdi-gray-900 truncate">{{ user()?.name }}</span>
            <span class="block text-xs text-sdi-gray-500 truncate">{{ user()?.email }}</span>
          </div>
          <button (click)="logout()" class="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2 transition-colors">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            Salir
          </button>
        </div>
      </div>
    </div>
  </div>
</header>

<!-- Mobile SideNav (Left) -->
@if (isMobileMenuOpen()) {
  <div class="md:hidden fixed inset-0 z-[100] animate-in fade-in duration-300">
    <!-- Backdrop -->
    <div 
      class="absolute inset-0 bg-sdi-gray-900/60 backdrop-blur-sm"
      (click)="isMobileMenuOpen.set(false)"
    ></div>
    
    <!-- Drawer -->
    <div class="absolute left-0 top-0 bottom-0 w-72 bg-white shadow-2xl animate-in slide-in-from-left duration-300 flex flex-col">
      <div class="p-6 border-b border-sdi-gray-100 flex items-center justify-between">
        <span class="font-bold text-sdi-royal">Navegación</span>
        <button (click)="isMobileMenuOpen.set(false)" class="p-2 text-sdi-gray-400">✕</button>
      </div>
      
      <div class="flex-1 p-4 space-y-2">
        <a 
          routerLink="/dashboard" 
          (click)="isMobileMenuOpen.set(false)"
          routerLinkActive="bg-sdi-blue-light text-sdi-royal font-bold"
          class="flex items-center gap-3 px-4 py-4 rounded-2xl text-sdi-gray-600 font-medium transition-all"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
          </svg>
          Dashboard
        </a>
        <a 
          routerLink="/initiatives" 
          (click)="isMobileMenuOpen.set(false)"
          routerLinkActive="bg-sdi-blue-light text-sdi-royal font-bold"
          class="flex items-center gap-3 px-4 py-4 rounded-2xl text-sdi-gray-600 font-medium transition-all"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
          Iniciativas
        </a>
        @if (user()?.role === 'admin' || user()?.role === 'director') {
          <a 
            routerLink="/direction-tasks" 
            (click)="isMobileMenuOpen.set(false)"
            routerLinkActive="bg-sdi-blue-light text-sdi-royal font-bold"
            class="flex items-center gap-3 px-4 py-4 rounded-2xl text-sdi-gray-600 font-medium transition-all"
          >
            <i class="ri-direction-line text-lg"></i>
            Tareas Dirección
          </a>
        }
        @if (user()?.role === 'admin') {
          <a 
            routerLink="/user-management" 
            (click)="isMobileMenuOpen.set(false)"
            routerLinkActive="bg-sdi-blue-light text-sdi-royal font-bold"
            class="flex items-center gap-3 px-4 py-4 rounded-2xl text-sdi-gray-600 font-medium transition-all"
          >
            <i class="ri-user-settings-line text-lg"></i>
            Usuarios
          </a>
        }
      </div>

      <div class="p-6 border-t border-sdi-gray-100 bg-sdi-gray-50">
        <div class="flex items-center gap-3 mb-6">
          <div class="w-10 h-10 rounded-full bg-sdi-royal text-white flex items-center justify-center font-bold">
            {{ initials() }}
          </div>
          <div class="overflow-hidden">
            <div class="text-sm font-bold text-sdi-gray-900 truncate">{{ user()?.name }}</div>
            <div class="text-[10px] text-sdi-gray-500 truncate">{{ user()?.email }}</div>
          </div>
        </div>
        <button (click)="logout()" class="w-full py-4 bg-white border border-red-100 text-red-600 rounded-2xl font-bold flex items-center justify-center gap-2 shadow-sm">
          <span>Cerrar Sesión</span>
        </button>
      </div>
    </div>
  </div>
}

<main class="max-w-[1440px] mx-auto px-4 md:px-10 py-6 md:py-10 animate-in fade-in transition-all duration-500">
  <router-outlet></router-outlet>
</main>


